import { render, staticRenderFns } from "./ModalDisableTwoFa.vue?vue&type=template&id=06e0fc46&scoped=true"
import script from "./ModalDisableTwoFa.vue?vue&type=script&lang=js"
export * from "./ModalDisableTwoFa.vue?vue&type=script&lang=js"
import style0 from "./ModalDisableTwoFa.vue?vue&type=style&index=0&id=06e0fc46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e0fc46",
  null
  
)

export default component.exports